import { blue50 } from '../../../colors/blue';
import { gray85, white } from '../../../colors/gray';
// Constants.
export var HOVER_BRIGHTNESS_LEVEL = 1.1;
export var INACTIVE_BRIGHTNESS_LEVEL = 1.4;
export var INACTIVE_SATURATION_LEVEL = 0.4;
// Compact shape.
export var DEFAULT_COMPACT_SHAPE_COLOR = gray85;
export var DEFAULT_COMPACT_SHAPE_SIZE = 12;
// Shape.
export var DEFAULT_SHAPE_COLOR = gray85;
export var DEFAULT_SHAPE_HEIGHT = 32;
export var DEFAULT_SHAPE_WIDTH = 30;
// Icon.
export var DEFAULT_ICON_COLOR = white;
export var DEFAULT_ICON_SIZE = 16;
export var ANIMATION_SETTINGS = {
    animationDuration: '350ms',
    transition: '50ms ease-out',
};
/**
 * A constant used for animations of the shape icons. Represents icon sizes (the object keys)
 * and their widths and heights for each animation step.
 */
export var SCALES_PER_ICON_SIZE = {
    default: {
        name: 'pinToPin',
        transforms: [
            // Animation step 1.
            {
                translateX: 0,
                translateY: 0,
                scale: 1,
            },
            // Animation step 2.
            {
                translateX: 0,
                translateY: 0,
                scale: 0.875,
            },
            // Animation step 3.
            {
                translateX: 0,
                translateY: -8,
                scale: 1.3,
            },
            // Animation step 4.
            {
                translateX: 0,
                translateY: -5,
                scale: 1.15,
            },
            // Animation step 5.
            {
                translateX: 0,
                translateY: -5,
                scale: 1.15,
            },
        ],
    },
    defaultBadge: {
        name: 'pinToPinBadge',
        transforms: [
            // Animation step 1.
            {
                translateX: 0,
                translateY: 0,
                scale: 1,
            },
            // Animation step 2.
            {
                translateX: -1,
                translateY: 1,
                scale: 0.875,
            },
            // Animation step 3.
            {
                translateX: 4,
                translateY: -13,
                scale: 1.3,
            },
            // Animation step 4.
            {
                translateX: 2,
                translateY: -8,
                scale: 1.15,
            },
            // Animation step 5.
            {
                translateX: 2,
                translateY: -8,
                scale: 1.15,
            },
        ],
    },
    large: {
        name: 'pinToPinLarge',
        transforms: [
            // Animation step 1.
            {
                translateX: 0,
                translateY: 0,
                scale: 1,
            },
            // Animation step 2.
            {
                translateX: 0,
                translateY: 0,
                scale: 0.9,
            },
            // Animation step 3.
            {
                translateX: 0,
                translateY: -8,
                scale: 1.22,
            },
            // Animation step 4.
            {
                translateX: 0,
                translateY: -5,
                scale: 1.11,
            },
            // Animation step 5.
            {
                translateX: 0,
                translateY: -5,
                scale: 1.11,
            },
        ],
    },
    largeBadge: {
        name: 'pinToPinLargeBadge',
        transforms: [
            // Animation step 1.
            {
                translateX: 0,
                translateY: 0,
                scale: 1,
            },
            // Animation step 2.
            {
                translateX: -2,
                translateY: 2,
                scale: 0.9,
            },
            // Animation step 3.
            {
                translateX: 4,
                translateY: -12,
                scale: 1.22,
            },
            // Animation step 4.
            {
                translateX: 2,
                translateY: -7,
                scale: 1.11,
            },
            // Animation step 5.
            {
                translateX: 2,
                translateY: -7,
                scale: 1.11,
            },
        ],
    },
};
// Styles.
export var COMMON_STYLES = {
    label: {
        color: blue50,
        margin: '0 auto',
        pointerEvents: 'none',
    },
};
